import { useQuery } from '@tanstack/react-query'

import type { BookingConfirmationSummary } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { bookingSessionKeys } from './keys.js'

export const useBookingConfirmationSummary = (sessionId: string | undefined) =>
  useQuery({
    enabled: !!sessionId,
    queryFn: async () => {
      const response = await apiClient.client.get<BookingConfirmationSummary>(
        `/booking-session/${sessionId}/summary`
      )
      return response.data
    },
    queryKey: sessionId ? bookingSessionKeys.summary(sessionId) : bookingSessionKeys.all,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
